import http from "../http";
import axios from 'axios';

// export all dashboard services 
export const pmProjectsService = {
    getProjectListService,
    getProjectInvoicesListService,
    getProjectInvoiceDetailsService,
    updateInvoiceService,
    releaseInvoiceService,
    uploadPdfForInvoiceService,
    uploadPdfForChangeOrderService,
    projectOverviewDetailsService,
    getProjectTimelineListService,
    updateTaskConnectionsService,
    getProjectTasksService,
    projectOverviewTaskDetailsService,
    projectMilestonesService,
    getProjectPhasesList,
    addProjectTaskService,
    updateProjectTaskService,
    deleteProjectTaskService,
    inlineUpdateProjectTaskService,
    getChangeOrderService,
    getChangeOrderItemsService,
    createChangeOrderService,
    saveChangeOrderService,
    getChangeOrderDetailsService,
    getChangeOrderTermsService,
    saveChangeOrderNotesService,
    saveChangeOrderIntroService,
    uploadChangeOrderPdfService,
    changeOrderAttachmentListService,
    removeChangeOrderAttachmentService,
    exportChangeOrderService,
    deleteChangeOrderService,
    duplicateChangeOrderService,
    getCOPaymentScheduleService,
    updateCOPaymentScheduleService,
    rfpListService,
    createRfpService,
    updateRfpService,
    unreleaseChangeOrder,
    rearrangeProjectOverviewDetailsService,
    generateZip,
    getProjectCameraService,
    getProjectCameraFeedsService,
    stopProjectCameraFeedsService,
    getProjectRfqsService,
    rfqsDetailsService,
    uploadDocumentMediaServices,
    deleteDocumentMediaService,
    updateDocumentOrderService,
    getProjectRfqSubcontractorsService,
    updateProjectRfqService,
    deleteProjectRfqService,
    submitManualBidService,
    rfqChangeClosingDateService,
    generateRfqPdfService,
    rejectBidService,
    acceptBidService,
    getPurchaseOrderListService,
    getPODetailsService,
    uploadPODocumentMediaServices,
    changePOFileAttachmentSequence,
    deletePOFileAttachmentService,
    getPOPaymentScheduleService,
    savePOPaymentScheduleService,
    updatePODetailsService,
    releasePurchaseOrderService,
    deletePurchaseOrderService,
    unreleasePurchaseOrderService,
    getAcceptedRfqBidsListingService,
    createPurchaseOrderService,
    exportPurchaseOrder,
    getProjectExpenseList,
    getExpensesPaymentReviewService,
    updateExpenseService,
    updateEstimatedExpenseService,
    createExpenseNoteService,
    getExpenseNotesService,
    approveExpenseService,
    rejectExpenseService,
    attachSubcontractorToExpenseService,
    exportCSVDataForRFQService,
    getGlobalRfqAttachmentsService,
    uploadGlobalRfqAttachmentService,
    deleteGlobalRfqAttachmentService,
    projectAutocompleteService,
    copyTimelineFromProjectService,
    poReviewService
}
// get projects list service
function getProjectListService(payload: any) {
    return http.get(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.id}/projects`);
}

// get project-center invoices list Service
function getProjectInvoicesListService(payload: {pm_id:string, dealId: string}) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pm_id}/project/${payload?.dealId}/invoices`);
}

// get project-center invoice details service
function getProjectInvoiceDetailsService(payload: {pm_id:string, dealId: string, invoiceId: string}) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pm_id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}`);
}

// update invoice service
function updateInvoiceService(payload: {id:any, dealId: string, invoiceId: string, data: any}){
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}`, {
    ...payload?.data
  });
}

function releaseInvoiceService(payload: {pm_id:any, dealId: string, invoiceId: string}){
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pm_id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}/release`);
}

function uploadPdfForInvoiceService(payload: any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.dealId}/invoice/${payload?.invoiceId}/upload`,
    payload?.data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

function uploadPdfForChangeOrderService(payload: any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/${payload?.id}/sign`,
    payload?.data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

// get project overview details service
function projectOverviewDetailsService(payload: any){
// 447abd28-e8ec-4326-b638-afdca1c0658b
// use this id for testing. later replace it with logged in user id
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/v2/${payload?.id}/project/${payload?.projectId}/overview`, {
    sort: {

    },
    tab: payload?.tab? payload?.tab: "",
    filters: payload?.filters
  });
}

// get project overview details service
function rearrangeProjectOverviewDetailsService(payload: any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.userId}/project/${payload?.projectId}/item-sequence`, {
    task: payload?.tasks ? payload?.tasks : []
  });
}

// get project tasks list for gantt chart service
// change
function getProjectTimelineListService(payload: any){
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.projectId}/${payload?.timeline?'timeline-listing': 'timeline'}`);
}

// update project task connections for gantt chart service
// change
function updateTaskConnectionsService(payload: any){
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task/${payload?.taskId}/connections`, {
    connections: payload?.data
  });
}

// get phase-wise tasks list for a project service
// change
function getProjectTasksService(payload: any){
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/tasks`);
}

// get project overview task details service
// change
function projectOverviewTaskDetailsService(payload: any){
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task/${payload?.taskId}`);
}

// get valid project milestones to link to task
function projectMilestonesService(payload: any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/unreleased-invoices`);
}


// get all project phases service
function getProjectPhasesList(payload: any) {
    return http.get(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.projectId}/phases`);
}

// Add project task service
// change
function addProjectTaskService(payload: any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task`, {
    ...payload?.taskObj
  })
}

// update project task service
// change
function updateProjectTaskService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task/${payload?.taskId}`, {
    ...payload?.taskObj
  })
}

// delete project task service
// change
function deleteProjectTaskService(payload: any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task/${payload?.taskId}`);
}

// inline update project task service
function inlineUpdateProjectTaskService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.dealId}/timeline/task/${payload?.taskId}/inline-update`, {
    ...payload?.data
  })
}

// get change-order Service
function getChangeOrderService(payload: {dealId:any, sort:any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/${payload?.dealId}/change-order/list`, {
    sort: payload.sort
  });
}

// get change-order items
function getChangeOrderItemsService(payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/change-order/get-item`, payload);
}

// create change order
function createChangeOrderService(dealId:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/${dealId}/change-order`);
}

// save change order
function saveChangeOrderService(change_order_id:any, payload:any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/${change_order_id}/items`, payload);
}

// get change order details
function getChangeOrderDetailsService(change_order_id:any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/project/change-Order/${change_order_id}`);
}

// get change order terms
function getChangeOrderTermsService(change_order_id:any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/change-order/${change_order_id}/terms`);
}

// save change order notes
function saveChangeOrderNotesService(change_orde_id:any,payload:any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/change-order/${change_orde_id}/notes`, payload);
}

// save change order Intro
function saveChangeOrderIntroService(payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/change-order/${payload?.change_order_id}/terms`, payload?.data)
}

// upload change order pdf service
function uploadChangeOrderPdfService(payload:{formData:any, id:any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/${payload?.id}/attachment`,
  payload?.formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  )
}

// uploaded change order doc list service
function changeOrderAttachmentListService(change_order_id:any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/${change_order_id}/attachment`)
}

// remove uploaded change order attachment service
function removeChangeOrderAttachmentService(attachmentId:any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/attachment/${attachmentId}`)
}

// view as pdf and release service
function exportChangeOrderService(change_order_id:any,payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/${change_order_id}/pdf`, payload)
}

// delete change order service
function deleteChangeOrderService(change_order_id:any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/${change_order_id}`)
}

// duplicate change order service
function duplicateChangeOrderService(change_order_id:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/${change_order_id}/duplicate`)
}

// get change order payment schedule 
function getCOPaymentScheduleService(change_order_id:any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/get-payment-schedule/${change_order_id}`)
}

// get change order payment schedule 
function updateCOPaymentScheduleService(payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/save-payment-schedule`, {
    ...payload
  })
}

// Create rfp service
function createRfpService(payload: any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/${payload.dealId}/rfp/${payload.id}`, payload.body)
}

// rfp listing service
function rfpListService(payload: {dealId:any, sort:any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/${payload?.dealId}/rfp`, {
    sort: payload.sort
  });
}

// rfp listing service
function updateRfpService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/project/${payload?.dealId}/rfp/${payload?.id}`, payload?.body)
}

// Unrelease change order
function unreleaseChangeOrder(change_orde_id:any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/pm/project/change-order/${change_orde_id}/unrelease`)
}

// Generate zip 
function generateZip(payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/project/rfp/${payload?.id}/generate-rfp-zip`, payload?.body)
}


// get project camera list
function getProjectCameraService(id: any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/${id}/cameras?active=true`);
}

// get project camera list
function getProjectCameraFeedsService(token: any) {
  return axios.get(`${process.env.REACT_APP_CAMERA_FEED_URL}/camera/feed/?token=${token}&TTL=5`);
}

// get project camera list
function stopProjectCameraFeedsService(token: any) {
  return axios.post(`${process.env.REACT_APP_CAMERA_FEED_URL}/camera/stop/?token=${token}`);
}

// get rfqs list
function getProjectRfqsService(payload: any) {
  return axios.post(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfqs`, 
    payload?.body
  );
}

// get rfqs subs list
function getProjectRfqSubcontractorsService(payload: any) {
  return axios.get(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/${payload?.rfqId}/subcontractors`);
}

// get rfqs Details 
function rfqsDetailsService(payload: {dealId:any, rfqId:any}){
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/${payload.dealId}/rfq/${payload.rfqId}`)
}

// Upload Document / Media Files for the rfq 
function uploadDocumentMediaServices(payload : any, dealId : any , rfqId : any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/projects/${dealId}/rfq/${rfqId}/attachments`,
    payload,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  )
}

// Delete the Document / Media Files
function deleteDocumentMediaService(payload : any){
  return http.delete(`${process.env.REACT_APP_BASE_URL}/projects/${payload.dealId}/rfq/${payload.rfqId}/attachments/${payload.attachmentId}`)
}

// Change The Document Order Service
function updateDocumentOrderService(payload : any){
  return http.put(`${process.env.REACT_APP_BASE_URL}/projects/${payload.dealId}/rfq/${payload.rfqId}/attachments/${payload.attachmentId}`,
    { sequence: payload.sequence }
  )
}

// update rfq 
function updateProjectRfqService(payload: any) {
  return axios.put(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/${payload?.rfqId}`, 
    payload?.body
  );
}

// delete rfq 
function deleteProjectRfqService(payload: any) {
  return axios.delete(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/${payload?.rfqId}`);
}

// submit manual bid
function submitManualBidService(payload: any) {
  return axios.post(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/rfq/${payload?.rfqId}/submit-bid`, 
    payload?.body
  );
}

// rfq change closing date
function rfqChangeClosingDateService(payload: any) {
  return axios.put(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/${payload?.rfqId}/change-closing-date`, 
    payload?.body
  );
}

//generate the pdf
function generateRfqPdfService(payload: any) {
  return axios.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/rfq/${payload?.rfqId}/export-pdf`,
    { responseType: 'blob' }
  );
}

// Reject Bid Service
function rejectBidService(payload: any) {
  return axios.put(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/${payload?.rfqId}/subcontractor/${payload?.subId}/reject`);
}

// Accept Bid Service
function acceptBidService(payload: any) {
  return axios.put(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/${payload?.rfqId}/subcontractor/${payload?.subId}/accept`);
}

// get Purchase Order List Service
function getPurchaseOrderListService(payload: any){
  return axios.post(`${process.env.REACT_APP_BASE_URL}/po/${payload?.dealId}`, 
    payload?.body
  )
}

// purchase order review service
function poReviewService(payload: any){
  return axios.put(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/po/${payload?.poId}/review`, 
    payload?.body
  )
}

// get Purchase Order Details
function getPODetailsService(payload: any) {
  return axios.get(`${process.env.REACT_APP_BASE_URL}/po/${payload?.poId}`);
}

// upload Purchase Order DocumentMedia Service
function uploadPODocumentMediaServices(payload: any, poId: any ) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/po/${poId}/attachments`,
    payload,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  )
}


// Change PO File Attachment Sequence
function changePOFileAttachmentSequence(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/po/${payload?.poId}/attachment/${payload?.attachmentId}`,
    { sequence: payload.sequence }
  )
}

//Delete PO File Attachment
function deletePOFileAttachmentService(payload: any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/po/${payload?.poId}/attachment/${payload?.attachmentId}`);
}

// get Payment Schedule Details
function getPOPaymentScheduleService(payload: any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/po/${payload?.poId}/get-payment-schedule`);
}

// Save Payment Schedule
function savePOPaymentScheduleService(payload: any) {
  const { poId, ...body } = payload;
  return http.post(`${process.env.REACT_APP_BASE_URL}/po/${poId}/save-payment-schedule`, 
    body
  );
}

// update PO Details
function updatePODetailsService(payload: any){
  return axios.put(`${process.env.REACT_APP_BASE_URL}/po/${payload?.poId}`, 
    payload?.body
  );
}

// Release PO Service
function releasePurchaseOrderService(payload: any){
  return axios.put(`${process.env.REACT_APP_BASE_URL}/po/${payload?.poId}/release`);
}

// delete PO Service
function deletePurchaseOrderService(payload: any){
  return axios.delete(`${process.env.REACT_APP_BASE_URL}/po/${payload?.poId}`);
}

// unRelease PO Service
function unreleasePurchaseOrderService(payload: any){
  return axios.put(`${process.env.REACT_APP_BASE_URL}/po/${payload?.poId}/unrelease`);
}
// get accepted RFQ bids listing service
function getAcceptedRfqBidsListingService(payload: any){
  return axios.post(`${process.env.REACT_APP_BASE_URL}/po/${payload?.dealId}/get-sub-with-rfqs`, payload?.body)
}

// create purchase order service
function createPurchaseOrderService(payload: { dealId: string, data: { subcontractors: Array<{ id: string, rfqIds: string[] }> } }) {
    return axios.post(`${process.env.REACT_APP_BASE_URL}/po/${payload.dealId}/generate-po`, payload.data);
}

// export purchase order pdf service
function exportPurchaseOrder(payload: { poId: string }) {
  return axios.get(`${process.env.REACT_APP_BASE_URL}/po/${payload.poId}/export-pdf`, {
    responseType: 'blob'
  });
}

// fetch Expenses Service
function getProjectExpenseList(payload: any) {
  const query = payload?.viewBy? `?viewBy=${payload?.viewBy}`: '';
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense${query}`, 
    payload?.body
  );
}

// get expenses PaymentReview Service
function getExpensesPaymentReviewService(payload: any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense/${payload?.expenseId}`);
}

// update Expense Service
function updateExpenseService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense/${payload?.expenseId}`, 
    payload?.body
  );
}

// update Estimated Expense Service
function updateEstimatedExpenseService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense/${payload?.expenseId}/update-estimated`, 
    payload?.body
  );
}

// Create Notes For Expenses(Payment Review Modal) Service
function createExpenseNoteService(payload: any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense/${payload?.expenseId}/note`, 
    payload?.data
  );
}

// Get Notes For Expenses(Payment Review Modal) Service
function getExpenseNotesService(payload: any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense/${payload?.expenseId}/note`);
}

// Approve the expense Service
function approveExpenseService(payload: any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense/${payload?.expenseId}/approve`,
    payload?.data
  );
}

// Reject The Expense Service
function rejectExpenseService(payload: any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense/${payload?.expenseId}/reject`,
    payload?.data
  );
}

// Attach Subcontractor To Estimated Expense Service
function attachSubcontractorToExpenseService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/expense/${payload?.expenseId}/update-estimated`,
    payload?.data
  );
}

// export the CSV DATA
function exportCSVDataForRFQService(payload: any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfqs/export-csv`);
}

// Projects Autocomplete service
function projectAutocompleteService(search: string) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/pm/project/auto-complete?term=${search}`);
}

// copy timeline from project
function copyTimelineFromProjectService(payload: any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/pm/${payload?.pmId}/project/${payload?.dealId}/copy-timeline-tasks`, payload?.body);
}

// get global rfq attachments
function getGlobalRfqAttachmentsService(payload: any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/global-files`);
}

// upload global rfq attachment
function uploadGlobalRfqAttachmentService(payload: any) {

  return http.post(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/global-file`,
    payload?.formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

// delete global rfq attachment
function deleteGlobalRfqAttachmentService(payload: any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.dealId}/rfq/global-file/${payload?.fileId}`);
}

